import { getUser } from "@/api/users";
import { Button } from "@/components/ui/button";
import { RoleType, User } from "@/models/user.model";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import StaffInfoTab from "./StaffInfoTab";
import EmploymentInfoTab from "./EmploymentInfoTab";
import PaymentInfoTab from "./PaymentInfoTab";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Card from "@/components/Card";
import { ChevronLeft, Delete, MoreHorizontal, Trash2 } from "lucide-react";
import BasicInfo from "./BasicInfo";
import { LeaveRequestDTO } from "@/models/leave-requests.model";
import LeaveAllowanceTab from "./LeaveAllowanceTab";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DeleteUserDialog } from "./DeleteUserDialog";
import { LeaveBalanceDTO } from "@/models/leave-balances.model";
import { getLeaveBalancesOfUser } from "@/api/leave-balances";
import IndivPageSkeleton from "@/components/skeletons/IndivPageSkeleton";
import BackButton from "@/components/buttons/BackButton";
import LeaveBalanceDataTable from "@/components/leave-balance/table/LeaveBalanceDataTable";
import LeaveBalanceCard from "@/components/leave-balance/LeaveBalanceCard";
import AdminLeaveRequestCard from "@/components/leave-request/AdminLeaveRequestCard";
import { toast } from "@/hooks/use-toast";

function IndivStaffPage() {
  const { id } = useParams();
  console.log(id);
  const userId = Number(id);

  const [user, setUser] = useState<User | null>(null);
  const [leaveBalance, setLeaveBalance] = useState<LeaveBalanceDTO[]>([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return;
      const user = await getUser(userId);
      setUser(user);
    };

    const fetchLeaveBalance = async () => {
      console.log("fetching leave balance for user", userId);
      if (!userId) return;
      try {
        const res = await getLeaveBalancesOfUser(userId, new Date().getFullYear());
        setLeaveBalance(res);
      }
      catch (err) {
        console.error(err);
        toast({
          variant: "destructive",
          title: "Failed to fetch leave balance",
          description: "Please try again later",
        })
      }
    };
    fetchUser();
    fetchLeaveBalance();
  }, [id]);
  if (!user) return <IndivPageSkeleton />;
  return (
    <div className="flex flex-col h-max w-full p-4 gap-5">
      <Card styles="flex flex-col p-4 gap-3 lg:h-[700px] h-max">
        <div className="flex justify-between mt-2">
          <BackButton link="/admin/users" label="Users" />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="h-8 w-8 p-0">
                <span className="sr-only">Open menu</span>
                <MoreHorizontal />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuLabel>Actions</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => setIsDeleteModalOpen(true)}>
                <Trash2 />
                Delete User
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>


        <div className="flex gap-10 w-full lg:flex-row flex-col">
          <div className="flex flex-col gap-5 min-w-[200px] lg:w-2/6">
            <BasicInfo user={user} setUser={setUser} />
          </div>
          <Tabs defaultValue="staff-info" className="w-full space-y-4">
            <TabsList className="w-full overflow-auto justify-start">
              <TabsTrigger value="staff-info" className="flex-1">
                Staff
              </TabsTrigger>
              <TabsTrigger value="employment-info" className="flex-1">
                Employment
              </TabsTrigger>
              <TabsTrigger value="payment-info" className="flex-1">
                Payment
              </TabsTrigger>
              <TabsTrigger value="leave-balance" className="flex-1">
                Leave Allowance
              </TabsTrigger>
            </TabsList>

            <TabsContent value="staff-info" className="mt-4">
              <StaffInfoTab userId={userId} user={user} />
            </TabsContent>

            <TabsContent value="employment-info" className="mt-4">
              <EmploymentInfoTab userId={userId} />
            </TabsContent>

            <TabsContent value="payment-info" className="mt-4">
              <PaymentInfoTab userId={userId} />
            </TabsContent>
            <TabsContent value="leave-balance" className="mt-4">
              <LeaveAllowanceTab
                userId={userId}
                leaveBalances={leaveBalance}
                setLeaveBalances={setLeaveBalance}
              />
            </TabsContent>
          </Tabs>
        </div>
      </Card>

      <div className="flex w-full gap-5 pb-5 lg:flex-row flex-col">
        <div className="overflow-auto flex-grow">

          <AdminLeaveRequestCard user={user} />
        </div>
        <div className="overflow-auto flex-grow">
          <LeaveBalanceCard userId={userId} />
        </div>
      </div>
      <DeleteUserDialog
        isOpen={isDeleteModalOpen}
        user={user}
        setIsOpen={setIsDeleteModalOpen}
      />
    </div>
  );
}

export default IndivStaffPage;
